var _excluded = ["fullName", "homeButton", "href", "isAuth", "lastLoggedInText", "marginBottom", "onHomeClick", "onLogoutClick", "safeSecureProps", "safeSecureText", "width"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable react/no-multi-comp */
import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import { useBrand } from "../BrandProvider";
import Container from "../Container";
import { Padlock } from "../Icon";
import BackgroundProvider from "../BackgroundProvider";
import Text from "../Text";
import { pxToRem, useWindowSize } from "../../utils";
import AuthHeader from "./AuthHeader";
import AuthMobileButtons from "./AuthMobileButtons";
import SafeSecureButton from "./SafeSecureButton";
import SafeSecureInformation from "./SafeSecureInformation";
import StyledHeader, { StyledHeaderContainer, StyledHeaderLogo, StyledHeaderSecureIconContainer, StyledHeaderSecureTextContainer, StyledHeaderTopContainer, StyledHeaderLogoLink, StyledHeaderButtonsContainer } from "./styled";
import { useTheme } from 'styled-components';
var AccessibleLogoTitle = function AccessibleLogoTitle(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  return children ? /*#__PURE__*/React.createElement("div", {
    className: "csl-sr-only"
  }, children) : null;
};

/**
 * Documentation:
 *
 * - [Link for Windows (On-prem)](https://pages.ghe.service.group/constellation/docs/components/header)
 **/
var Header = function Header(_ref2) {
  var _theme$assets, _theme$assets$logo, _theme$assets2, _theme$assets2$logo;
  var _ref2$fullName = _ref2.fullName,
    fullName = _ref2$fullName === void 0 ? '' : _ref2$fullName,
    _ref2$homeButton = _ref2.homeButton,
    homeButton = _ref2$homeButton === void 0 ? true : _ref2$homeButton,
    _ref2$href = _ref2.href,
    href = _ref2$href === void 0 ? '' : _ref2$href,
    _ref2$isAuth = _ref2.isAuth,
    isAuth = _ref2$isAuth === void 0 ? false : _ref2$isAuth,
    _ref2$lastLoggedInTex = _ref2.lastLoggedInText,
    lastLoggedInText = _ref2$lastLoggedInTex === void 0 ? '' : _ref2$lastLoggedInTex,
    _ref2$marginBottom = _ref2.marginBottom,
    marginBottom = _ref2$marginBottom === void 0 ? '06' : _ref2$marginBottom,
    _ref2$onHomeClick = _ref2.onHomeClick,
    onHomeClick = _ref2$onHomeClick === void 0 ? function () {} : _ref2$onHomeClick,
    _ref2$onLogoutClick = _ref2.onLogoutClick,
    onLogoutClick = _ref2$onLogoutClick === void 0 ? function () {} : _ref2$onLogoutClick,
    _ref2$safeSecureProps = _ref2.safeSecureProps,
    safeSecureProps = _ref2$safeSecureProps === void 0 ? {} : _ref2$safeSecureProps,
    _ref2$safeSecureText = _ref2.safeSecureText,
    safeSecureText = _ref2$safeSecureText === void 0 ? true : _ref2$safeSecureText,
    _ref2$width = _ref2.width,
    width = _ref2$width === void 0 ? 'default' : _ref2$width,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    safeSecureOpen = _useState2[0],
    setSafeSecureOpen = _useState2[1];
  var theme = useTheme() || {};
  var onSafeSecureClick = function onSafeSecureClick(e) {
    var _safeSecureButtonRef$;
    e.preventDefault();
    if (safeSecureOpen) safeSecureButtonRef === null || safeSecureButtonRef === void 0 ? void 0 : (_safeSecureButtonRef$ = safeSecureButtonRef.current) === null || _safeSecureButtonRef$ === void 0 ? void 0 : _safeSecureButtonRef$.focus();
    setSafeSecureOpen(!safeSecureOpen);
  };
  var _ref3 = useBrand() || {},
    brandTitle = _ref3.brandTitle;
  var classNames = classnames('csl-header', {
    'csl-header--open': safeSecureOpen
  });
  var _useWindowSize = useWindowSize(),
    windowWidth = _useWindowSize.width;
  var isNarrow = pxToRem(windowWidth) < parseFloat(theme === null || theme === void 0 ? void 0 : theme.breakpoint_lg);
  var isWide = !isNarrow;
  var Logo = isWide ? theme === null || theme === void 0 ? void 0 : (_theme$assets = theme.assets) === null || _theme$assets === void 0 ? void 0 : (_theme$assets$logo = _theme$assets.logo) === null || _theme$assets$logo === void 0 ? void 0 : _theme$assets$logo.wide : theme === null || theme === void 0 ? void 0 : (_theme$assets2 = theme.assets) === null || _theme$assets2 === void 0 ? void 0 : (_theme$assets2$logo = _theme$assets2.logo) === null || _theme$assets2$logo === void 0 ? void 0 : _theme$assets2$logo.base;
  var safeSecureButtonRef = useRef(null);
  var renderSafeAndSecureText = function renderSafeAndSecureText() {
    var safeAndSecureText = 'Safe & Secure';
    return safeAndSecureText;
  };
  return /*#__PURE__*/React.createElement(StyledHeader, _extends({
    $marginBottom: marginBottom
  }, rest, {
    className: classNames
  }), /*#__PURE__*/React.createElement(StyledHeaderContainer, {
    className: "csl-header__container"
  }, /*#__PURE__*/React.createElement(Container, {
    width: width
  }, /*#__PURE__*/React.createElement(BackgroundProvider, {
    value: {
      cssValue: theme.header_color_background
    }
  }, /*#__PURE__*/React.createElement(StyledHeaderTopContainer, {
    className: "csl-header__container-top"
  }, href ? /*#__PURE__*/React.createElement(StyledHeaderLogoLink, {
    href: href,
    title: brandTitle
  }, /*#__PURE__*/React.createElement(StyledHeaderLogo, {
    className: "csl-header__logo"
  }, Logo && /*#__PURE__*/React.createElement(Logo, null), /*#__PURE__*/React.createElement(AccessibleLogoTitle, null, brandTitle))) : /*#__PURE__*/React.createElement(StyledHeaderLogo, {
    className: "csl-header__logo"
  }, Logo && /*#__PURE__*/React.createElement(Logo, null), /*#__PURE__*/React.createElement(AccessibleLogoTitle, null, brandTitle)), /*#__PURE__*/React.createElement(StyledHeaderButtonsContainer, null, isAuth && isNarrow && /*#__PURE__*/React.createElement(AuthMobileButtons, {
    onHomeClick: onHomeClick,
    onLogoutClick: onLogoutClick,
    homeButton: homeButton
  }), (!isAuth || isWide) && /*#__PURE__*/React.createElement(SafeSecureButton, _extends({
    onSafeSecureClick: onSafeSecureClick,
    open: !!safeSecureOpen,
    ref: safeSecureButtonRef,
    safeSecureText: safeSecureText
  }, safeSecureProps), /*#__PURE__*/React.createElement(StyledHeaderSecureTextContainer, {
    className: "csl-header__secure-text-container"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "inherit",
    size: "s2",
    weight: theme.button_config_font_weight
  }, renderSafeAndSecureText()), /*#__PURE__*/React.createElement(StyledHeaderSecureIconContainer, {
    className: "csl-header__secure-icon-container"
  }, /*#__PURE__*/React.createElement(Padlock, {
    color: "inherit",
    iconSize: "lg",
    size: "s1"
  }))))))))), safeSecureText && /*#__PURE__*/React.createElement(SafeSecureInformation, {
    onSafeSecureClick: onSafeSecureClick,
    open: !!safeSecureOpen,
    safeSecureText: safeSecureText,
    width: width
  }), isAuth && isWide && /*#__PURE__*/React.createElement(AuthHeader, {
    fullName: fullName,
    homeButton: homeButton,
    lastLoggedInText: lastLoggedInText,
    onHomeClick: onHomeClick,
    onLogoutClick: onLogoutClick,
    width: width
  }));
};
AccessibleLogoTitle.displayName = 'AccessibleLogoTitle';
Header.displayName = 'Header';
export default Header;